import { TableHeaderCell } from '@components/Table/TableHeaderCell';
import { IData } from '@hooks/useData';
import useFormatter from '@hooks/useFormatter';
import { Table, TableHead, TableRow, TableBody, TableCell, IconButton, Tooltip } from '@material-ui/core';
import { IAtividade } from '@model/Atividade';
import React from 'react';
import SearchIcon from '@material-ui/icons/Search';
import { IModalWindow } from '@hooks/useModalWindow';
import { TableHeaderCellAction } from '@components/Table/TableHeaderCellAction';

export type AtividadeTableProps = {
    data: IData<IAtividade>
    diferencaModal: IModalWindow
}

export function AtividadeTable ({ data, diferencaModal}: AtividadeTableProps) {
    const formatter = useFormatter();

    return (
        <React.Fragment>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableHeaderCell>ID</TableHeaderCell>
                        <TableHeaderCell>Usuário</TableHeaderCell>
                        <TableHeaderCell>Data/Hora</TableHeaderCell>
                        <TableHeaderCell>Operação</TableHeaderCell>
                        <TableHeaderCell>Ação</TableHeaderCell>
                        <TableHeaderCell>Info</TableHeaderCell>
                        <TableHeaderCellAction />
                    </TableRow>
                </TableHead>

                <TableBody>
                {
                    data.items.map((atividade, index) => {
                        return (
                            <TableRow key={atividade.atividadeId}>
                                <TableCell>{atividade.atividadeId}</TableCell>
                                <TableCell>{atividade.usuarioNome}</TableCell>
                                <TableCell>{formatter.toDate(atividade.criadoEm)}</TableCell>
                                <TableCell>{atividade.operacao}</TableCell>
                                <TableCell>{atividade.acao}</TableCell>
                                <TableCell>{atividade.info}</TableCell>
                                <TableCell>
                                    <Tooltip title="Diferenças">
                                        <IconButton onClick={data.handleRowFocused(atividade, diferencaModal.open)}>
                                            <SearchIcon />
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        )
                    })
                }
                </TableBody>
            </Table>
       </React.Fragment>
    )
}